<template>
  <a-row :gutter="16" class="mb-32px">
    <a-col class="gutter-row" :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
      <div class="gutter-box box-shadow-green">
        <div class="d-flex jcb aic">
          <div>
            <div class="gutter-box-number">{{ data.current_user || '0' }}</div>
            <div class="gutter-box-label fs-md geomanist-font">{{ $t('label.current_pico_users') }}</div>
          </div>
          <div class="gutter-box-icon d-flex jcc aic green">
            <users-icon height="32" width="32" stroke="#2FC091"/>
          </div>
        </div>
        <a-button class="app-button primary gutter-box-btn mt-24px" @click="goToUsersWithPico">
          {{ $t('btn.details') }}
        </a-button>
      </div>
    </a-col>
    <a-col class="gutter-row" :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
      <div class="gutter-box box-shadow-yellow">
        <div class="d-flex jcb aic">
          <div>
            <div class="gutter-box-number">{{ data.active_bases || '0' }}</div>
            <div class="gutter-box-label fs-md geomanist-font">{{
                $tc('label.active_bases_out_of_total', data.all_bases)
              }}
            </div>
          </div>
          <div class="gutter-box-icon d-flex jcc aic yellow">
            <shield-check-icon height="32" width="32" stroke="#EABA13" view-box="0 0 32 32"/>
          </div>
        </div>
        <a-button class="app-button primary gutter-box-btn mt-24px" @click="goToActiveBases">
          {{ $t('btn.see_more') }}
        </a-button>
      </div>
    </a-col>
    <a-col class="gutter-row" :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
      <div class="gutter-box box-shadow-red">
        <div class="d-flex jcb aic">
          <div>
            <div class="gutter-box-number">{{ data.notifications || '0' }}</div>
            <div class="gutter-box-label fs-md geomanist-font">{{ $t('label.urgent_notifications') }}</div>
          </div>
          <div class="gutter-box-icon d-flex jcc aic red">
            <notifications-icon height="32" width="32" stroke="#FF655B" viewbox="0 0 50 50"/>
          </div>
        </div>
        <a-button class="app-button primary gutter-box-btn mt-24px" @click="goToUrgentNotifications">
          {{ $t('btn.see_more') }}
        </a-button>
      </div>
    </a-col>
  </a-row>
</template>

<script>
import NotificationsIcon from '@/assets/icons/notificationsIcon';
import ShieldCheckIcon from '@/assets/icons/shieldCheckIcon';
import UsersIcon from '@/assets/icons/usersIcon';

export default {
  components: {
    NotificationsIcon,
    ShieldCheckIcon,
    UsersIcon
  },
  props: {
    data: {
      type: Object, default: () => {
      }
    },
    organizationId: {type: Number, default: null}
  },
  methods: {
    goToUsersWithPico() {
      this.$router.push({name: 'Users', query: {organization_id: this.organizationId, pico_taken: null}});
    },
    goToActiveBases() {
      this.$router.push({name: 'Bases', query: {organization_id: this.organizationId, online: null}});
    },
    goToUrgentNotifications() {
      this.$router.push({name: 'Notifications', query: {urgent: null, new_event: null}});
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 992px) {
  .gutter-row {
    margin-bottom: 16px;
  }

  .gutter-box {
    padding: 16px 20px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    > div:first-child {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 12px;
    }

    .gutter-box-number {
      font-size: 20px;
      margin: 0;
    }

    .gutter-box-label {
      font-size: 18px;
      margin-top: 4px;
    }

    .gutter-box-btn {
      margin-top: 0;
      padding: 6px 20px;
      font-size: 14px;
      align-self: flex-end;
    }

    .gutter-box-icon {
      height: 36px;
      width: 36px;
      flex-shrink: 0;
    }
  }
}
</style>